import EnrollmentCoursesDataStore from '../../datastores/EnrollmentCoursesStore';

const data = [
  {
    id: '01',
    code: '1N031',
    name: 'Inglés I',
    hours: 4,
    credits: 8,
    type: 'O',
    cicle: 1
  },
  {
    id: '02',
    code: '1A674',
    name: 'Herramientas informáticas para el desarrollo en el ámbito profesional',
    hours: 4,
    credits: 3.5,
    type: 'E',
    cicle: 2
  },
  {
    id: '03',
    code: '2X102',
    name: 'Introducción a la vida universitaria',
    hours: 4,
    credits: 10.25,
    type: 'E',
    cicle: 4
  }
];

export default class EnrollmentCoursesDataStoreMock
  implements EnrollmentCoursesDataStore
{
  getEnrollmentCourses() {
    return data;
  }
}
